import { useParams, Link } from "react-router-dom";
import { useEffect } from "react";
import { Clock, ArrowLeft } from "lucide-react";
import { getTool, getCategory, toolIcon } from "@/lib/toolsData";
import { registry } from "@/components/registry";
import { ToolLayout } from "@/components/ToolLayout";
import { addRecent } from "@/lib/favorites";

const ToolPage = () => {
  const { slug } = useParams();
  const tool = getTool(slug);
  const Component = registry[slug];

  useEffect(() => {
    if (tool && tool.status === "live") addRecent(slug);
  }, [slug, tool]);

  // Coming soon tool (exists in catalog, no component yet)
  if (tool && tool.status === "soon") {
    const category = getCategory(tool.category);
    const Icon = toolIcon(tool);
    return (
      <div className="mx-auto max-w-2xl px-4 py-24 text-center animate-fade-up">
        <span className="mx-auto flex h-16 w-16 items-center justify-center border border-border bg-muted text-muted-foreground">
          {Icon && <Icon className="h-8 w-8" />}
        </span>
        <p className="mt-6 overline text-[#E53935]">Coming Soon</p>
        <h1 className="mt-2 font-heading text-4xl font-black tracking-tighter">{tool.name}</h1>
        <p className="mt-3 text-muted-foreground">This tool is on our roadmap and launching soon. Explore the {category?.name} that are live right now.</p>
        <Link to={`/category/${tool.category}`} data-testid="soon-back-category" className="mt-8 inline-flex items-center gap-2 bg-primary px-5 py-3 text-sm font-bold text-white transition-colors hover:bg-[#0A0A0A]">
          <ArrowLeft className="h-4 w-4" /> Browse {category?.name}
        </Link>
      </div>
    );
  }

  if (!tool || !Component) {
    return (
      <div className="mx-auto max-w-7xl px-4 py-24 text-center">
        <Clock className="mx-auto h-10 w-10 text-muted-foreground" />
        <h1 className="mt-4 font-heading text-3xl font-black">Tool not found</h1>
        <Link to="/" className="mt-4 inline-block text-primary hover:underline">← Back home</Link>
      </div>
    );
  }

  return (
    <ToolLayout tool={tool}>
      <Component />
    </ToolLayout>
  );
};

export default ToolPage;
